/**
 * SlideProducts Custom Element
 * A carousel component for displaying product slides with navigation tabs
 */
if (!customElements.get('slide-products')) {
    class SlideProducts extends HTMLElement {
        constructor() {
            super();
            this.autoplay = this.getAttribute('data-autoplay');
            this.autoplayDelay = this.getAttribute('data-autoplay-delay') || 3;
            this.slidesPerViewThumbs = this.getAttribute('data-slides-per-view') || 1;
            if (this.slidesPerViewThumbs > 1) this.init();
        }

        init() {
            console.log('slide-products-init');
            let autoplayOption = {
                delay: this.autoplayDelay * 1000,
                disableOnInteraction: true,
                pauseOnMouseEnter: true, // 鼠标划上时暂停
            };

            const swiperThumbs = new Swiper(this.querySelector('.swiper-thumbs'), {
                slidesPerView: this.slidesPerViewThumbs,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true
            });

            this.Swiper = new Swiper(this.querySelector('.swiper'), {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: this.autoplay != 'false' ? autoplayOption : false,
                pagination: {
                    el: '.swiper-pagination'
                },
                thumbs: {
                    swiper: swiperThumbs
                }
            });
        }
    }

    customElements.define('slide-products', SlideProducts);
}
